import React from "react";
import { connect } from "react-redux";
import { Card, Row, Col } from "reactstrap";
import reduxHelper from "./../../../helper/index.js";
import XpBar from "./XpBar.jsx";
import StreakWidget from "./StreakWidget.jsx";
import { getAvatarUrl } from "./../../../helper/avatarHelper.js";
import { getLevelGradient } from "./../../../helper/xpHelpers.js";

/**
 * Widget combo de gamificacao com:
 *  - Avatar do aluno destacado (aro colorido pelo level)
 *  - Barra de XP + level atual/proximo
 *  - Streak (chama de fogo)
 */
class GamificationSummaryWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
    this.helper = new reduxHelper(this.props);
  }

  async componentDidMount() {
    if (this.props.userId) {
      await Promise.all([
        this.helper.gamification().getXpProgress(this.props.userId),
        this.helper.gamification().getStreak(this.props.userId)
      ]);
    }
    this.setState({ loading: false });
  }

  render() {
    var g = this.props.gamification || {};
    var user = this.props.user || {};
    var levelNum = (g.currentLevel && g.currentLevel.level) || 1;
    var ringGradient = getLevelGradient(levelNum);
    var preferredStyle = (user.avatarStyle && typeof user.avatarStyle === 'string') ? user.avatarStyle : 'personas';
    var avatarUrl = getAvatarUrl({ id: user.id, photo: user.photo }, preferredStyle, { size: 200 });

    return (
      <Card className="shadow border-0">
        <Row className="no-gutters align-items-center">

          {/* Avatar com aro do level */}
          <Col xs="12" md="auto" className="text-center p-3">
            <div style={{
              position: 'relative',
              display: 'inline-block',
              padding: '4px',
              borderRadius: '50%',
              background: ringGradient,
              boxShadow: '0 4px 14px ' + (g.currentLevel && g.currentLevel.color ? g.currentLevel.color + '60' : 'rgba(0,0,0,0.1)')
            }}>
              <img
                src={avatarUrl}
                alt="avatar"
                style={{
                  width: '88px',
                  height: '88px',
                  borderRadius: '50%',
                  border: '3px solid #fff',
                  display: 'block',
                  backgroundColor: '#f8f9fa',
                  objectFit: 'cover'
                }}
              />
              {/* Badge do level no canto inferior direito */}
              <div style={{
                position: 'absolute',
                bottom: '0',
                right: '0',
                width: '32px',
                height: '32px',
                background: ringGradient,
                borderRadius: '50%',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: '0.85rem',
                border: '3px solid #fff',
                boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
              }}>
                {levelNum}
              </div>
            </div>
            <div className="mt-2">
              <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                {(g.currentLevel && g.currentLevel.name) || 'Bronze I'}
              </small>
            </div>
          </Col>

          {/* XP Bar */}
          <Col xs="12" md className="p-3">
            <XpBar
              totalXp={g.totalXp}
              currentLevel={g.currentLevel}
              nextLevel={g.nextLevel}
              xpToNextLevel={g.xpToNextLevel}
              percentToNext={g.percentToNext}
            />
            {g.globalPosition > 0 && (
              <small className="text-muted d-block mt-2 text-center">
                <i className="fas fa-trophy mr-1" style={{ color: '#FFD700' }} />
                Você está em <strong>#{g.globalPosition}</strong> no ranking global
              </small>
            )}
          </Col>

          {/* Streak */}
          <Col xs="12" md="3" className="p-3" style={{ borderLeft: '1px solid #eee' }}>
            <StreakWidget
              currentStreak={g.streak ? g.streak.currentStreak : 0}
              longestStreak={g.streak ? g.streak.longestStreak : 0}
            />
          </Col>
        </Row>
      </Card>
    );
  }
}

export default connect(state => ({
  gamification: state.gamification,
  translate: state.translate,
  user: state.user
}))(GamificationSummaryWidget);
